import { computed, Directive, input } from '@angular/core';

export type Stage = 'shared' | 'added' | 'authorise' | 'data';

const STAGE_ORDER: Stage[] = ['shared', 'added', 'authorise', 'data'];

/**
 * Shared inputs and stage helpers for the info box variants (`InfoBoxNew`, `InfoBoxRenewal`).
 * Abstract and selector-less, so it is never rendered on its own.
 */
@Directive()
export abstract class InfoBoxBase {
  brandColour = input<string>('');
  currentStage = input<Stage>('authorise');
  siteCount = input<number>(1);

  buildingPossessive = computed(() => this.siteCount() === 1 ? "building's" : "buildings'");

  /**
   * Returns `true` if the given stage has already been passed relative to `currentStage`.
   * @param stage : Stage - The stage to evaluate.
   */
  isCompleted(stage: Stage): boolean {
    return STAGE_ORDER.indexOf(stage) < STAGE_ORDER.indexOf(this.currentStage());
  }

  /**
   * Returns `true` if the given stage has not yet been reached relative to `currentStage`.
   * @param stage : Stage - The stage to evaluate.
   */
  isFuture(stage: Stage): boolean {
    return STAGE_ORDER.indexOf(stage) > STAGE_ORDER.indexOf(this.currentStage());
  }
}
